import { ref, reactive, onMounted, toRefs } from "vue";
import { useRoute } from "vue-router";
import { getCurrentInstance } from "vue";
import apis from "@/api";
import { deleteNoticeById } from "../../api/modules/Notice";
export default {
  name: "NoticeSetting",
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    const data = reactive({
      queryParam: {},
      title: "新增/编辑类型",
      visible: false,
      publisherHidden: true,
      popupForm: {
        id: "",
        typeName: "",
        fileFormat: "",
        createTime: ""
      },
      rulesValue: {
        typeName: [{
          required: true,
          message: "类型名称不能为空!",
          trigger: "change"
        }],
        fileFormat: [{
          required: true,
          message: "文件格式不能为空!",
          trigger: "change"
        }],
        createTime: [{
          required: true,
          message: "开始时间不能为空!",
          trigger: "change"
        }]
      },
      pageNo: 1,
      pageSize: 10,
      tableData: [],
      allData: [],
      columns: [{
        label: "类型编号",
        prop: "id"
      }, {
        label: "类型名称",
        prop: "typeName"
      }, {
        label: "支持文件格式",
        prop: "fileFormat"
      }],
      total: 0,
      currentPage: 1,
      searchFlag: false
    });
    const loadData = () => {
      apis.listType({
        pageNo: data.pageNo,
        pageSize: data.pageSize
      }).then(res => {
        if (res.success) {
          console.log("res:", res);
          data.total = res.data.total;
          data.tableData = res.data;
        }
      });
    };
    const resetForm = form => {
      proxy.$refs[form].resetFields();
    };
    const submitForm = form => {
      proxy.$refs[form].validate(valid => {
        if (valid) {
          data.searchFlag = true;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };
    const sizeChange = pageSize => {
      this.pageSize = pageSize;
      this.currentChange(this.currentPage);
    };
    const currentChange = currentPage => {
      console.log("currentPage:", currentPage);
      /* if (data.searchFlag) {
                    apis
                        .listNotice({
                            pageNo: currentPage,
                            pageSize: data.pageSize,
                            empName: data.queryParam.empName,
                        })
                        .then((res) => {
                            console.log("current:records->", res);
                            data.tableData = res.records;
                        });
                } else {
                    apis
                        .listNotice({pageNo: currentPage, pageSize: data.pageSize})
                        .then((res) => {
                            console.log("current:records->", res);
                            data.tableData = res.records;
                        });
                }*/
    };
    const addUser = () => {};
    onMounted(() => {
      loadData();
      console.log("初始化查询开始------------");
    });
    //显示弹窗
    const popupShow = (str, row) => {
      data.title = str.toString();
      data.visible = true;
      //如果是编辑，就会有原始数据
      if (str === "新增类型") {
        data.publisherHidden = true;
      }
      if (str === "编辑类型") {
        data.publisherHidden = false;
        data.popupForm.id = row.id;
        data.popupForm.typeName = row.typeName;
        data.popupForm.fileFormat = row.fileFormat;
        data.popupForm.createTime = row.createTime;
      }
    };
    //取消、重置弹窗
    const popupCancel = formName => {
      proxy.$refs[formName].resetFields();
      data.popupForm.status = "1";
      data.visible = false;
    };
    //提交数据
    const popupCommit = formName => {
      //form数据校验
      proxy.$refs[formName].validate(valid => {
        let typeEntity = {
          id: "",
          typeName: "",
          fileFormat: "",
          createTime: ""
        };
        if (valid) {
          if (data.title === "新增类型") {
            //新增公告提交
            typeEntity.id = data.popupForm.id;
            typeEntity.typeName = data.popupForm.typeName;
            typeEntity.fileFormat = data.popupForm.fileFormat;
            doAddType(typeEntity, formName);
          } else if (data.title === "编辑类型") {
            // 编辑公告提交
            typeEntity.id = data.popupForm.id;
            typeEntity.typeName = data.popupForm.typeName;
            typeEntity.fileFormat = data.popupForm.fileFormat;
            console.log(JSON.stringify(typeEntity));
            doUpdateType(typeEntity, formName);
          }
        } else {
          console.log("提交失败!");
          return false;
        }
      });
    };

    //新增公告
    const doAddType = (par, formName) => {
      apis.addType(par).then(res => {
        console.log(res);
        if (res.success) {
          popupCancel(formName);
          loadData();
        } else {}
      });
    };

    //修改公告
    const doUpdateType = (par, formName) => {
      apis.updateType(par).then(res => {
        if (res.success) {
          popupCancel(formName);
          loadData();
        } else {}
      });
    };
    const doDeleteType = row => {
      apis.deleteType({
        id: row.id
      }).then(res => {
        if (res.success) {
          loadData();
        } else {}
      });
    };

    //时间格式化
    const dateFormat = dateTime => {
      function addDateZero(num) {
        return num < 10 ? "0" + num : num;
      }
      let d = new Date(dateTime);
      let formatDatetime = d.getFullYear() + "-" + addDateZero(d.getMonth() + 1) + "-" + addDateZero(d.getDate()) + " " + addDateZero(d.getHours()) + ":" + addDateZero(d.getMinutes()) + ":" + addDateZero(d.getSeconds());
      return formatDatetime;
    };

    //判断时间字符串中是否有字母
    const hasLetter = str => {
      let regString = /[a-zA-Z]+/;
      if (str) {
        return regString.test(str);
      }
    };
    return {
      ...toRefs(data),
      proxy,
      loadData,
      resetForm,
      submitForm,
      currentChange,
      sizeChange,
      popupShow,
      popupCancel,
      popupCommit,
      doAddType,
      dateFormat,
      hasLetter,
      doUpdateType,
      doDeleteType
    };
  }
};